import { Pressable, Image } from 'react-native'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import useDimension from '../../../hooks/use-dimension'
import PageBg from '../../../components/PageBg'
import { imgWelcome, imgEnd } from '../../../data/images'
import { useEffect, useRef } from 'react'
import {
  GameHints,
  GamePasses,
  useGameContext,
} from '../../../context/GameContext'
import { resetAll } from '../../../utils/resetFunctions'
import { useLocalStorage } from 'react-use'
import { useAudio } from '../../../context/AudioContext'

const { bgWelcome } = imgWelcome
const { btnRestart, btnVideo } = imgEnd

function Final() {
  const { ws } = useDimension()
  const navigate = useNavigate()
  const { setVolumeValue } = useAudio()
  const {
    updatePasses,
    updateHints,
    updateRole,
    updateSelectRole,
    updateVideo,
  } = useGameContext()

  const [, , remove] = useLocalStorage<{
    passes: GamePasses
    hints: GameHints
    role: string
  } | null>('loveproducer', null)

  const onRestart = () => {
    resetAll({
      remove,
      updatePasses,
      updateHints,
      updateRole,
      updateSelectRole,
      updateVideo,
    })
    navigate('/', { replace: true })
    // setVolumeValue(0)
    // window.open('/', '_blank')
  }
  const audioRef = useRef(new Audio('/audio/bg-music.mp3'))

  const onVideo = () => {
    setVolumeValue(0)
    navigate('/endvideo', { replace: true })
  }

  useEffect(() => {
    audioRef.current.loop = true
  }, [])

  return (
    <PageBg src={bgWelcome} alt={`bg-welcome`}>
      <motion.div
        className="motion-wrapper btn"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 1 }}
        style={{
          position: 'absolute',
          top: 490.5 * ws,
          left: 50 * ws,
          width: 124.5 * ws,
          height: 36.5 * ws,
          display: 'flex',
          gap: 20 * ws,
        }}
      >
        <Pressable
          style={({ pressed }) => [
            {
              opacity: pressed ? 0.5 : 1.0,
            },
          ]}
          onPress={onRestart}
        >
          <Image
            source={{ uri: btnRestart }}
            style={{
              width: 124.5 * ws,
              height: 36.5 * ws,
            }}
            resizeMode="cover"
            aria-label={`btn-restart`}
          />
        </Pressable>
        <Pressable
          style={({ pressed }) => [
            {
              opacity: pressed ? 0.5 : 1.0,
            },
          ]}
          onPress={onVideo}
        >
          <Image
            source={{ uri: btnVideo }}
            style={{
              width: 124.5 * ws,
              height: 36.5 * ws,
            }}
            resizeMode="cover"
            aria-label={`btn-restart`}
          />
        </Pressable>
      </motion.div>
    </PageBg>
  )
}

export default Final
